import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { FilterMatchMode, FilterOperator } from 'primereact/api'
import {
  DataTable,
  DataTableBaseProps,
  DataTableFilterMeta,
  DataTableFilterMetaData,
  DataTableState,
  DataTableValueArray,
} from 'primereact/datatable'
import { TreeTable, TreeTableProps } from 'primereact/treetable'
import { useSessionstorageState } from 'rooks'
import { useImmer } from 'use-immer'

import {
  Roles,
  useAllRoles,
} from '../../../features/selfservice/roleAssignments/data'
import {
  SupplierList,
  useAllSuppliers,
} from '../../../features/selfservice/suppliers/data'
import { TableConfig } from '../../../features/ui-config'
import { Constants } from '../../constants'
import { getConfigTranslation } from '../../helper/getConfigTranslation'
import { SupportedLanguage } from '../../i18n'
import { EmptyMessage } from './EmptyMessage'
import { LoadingTable } from './LoadingTable'
import { createColumns, createHeader } from './create'
import { createTreeColumns } from './create/createTreeColumns'
import { getFilterMatchMode } from './getter'

interface Props extends TreeTableProps {
  config: TableConfig
  buttons?: JSX.Element
  // data?: any
  // dataKey?: string
  // header?: JSX.Element
  headerTitle?: string
  headerActions?: JSX.Element

  // buttons?:
  checkboxen?: boolean
  // selected?: any
  // setSelected?: (params: any) => void
  // globalFilterValue?: string
  // isLoading?: boolean
  // setGlobalFilterValue?:
  //   | React.Dispatch<React.SetStateAction<string>>
  //   | ((value: string) => void)
  // stateKey: string
  children?: JSX.Element[] //React.ReactNode
}

export interface DropDownOptions {
  roles?: Roles
  suppliers?: SupplierList
}

export const ConfigurableTreeTable: React.FC<Props> = ({
  config,
  buttons,
  // data,
  // dataKey = 'Id',
  // header,
  headerTitle,
  headerActions,
  checkboxen = false,
  // selected,
  // setSelected,
  // globalFilterValue,
  // isLoading,
  // setGlobalFilterValue,
  // stateKey,
  children,
  ...props
}) => {
  const { t } = useTranslation()
  // const navigate = useNavigate()
  // const { data: roles } = useAllRoles()
  // const { data: suppliers } = useAllSuppliers()
  // const dataTableRef = useRef<DataTable<any>>(null)

  // const [tableState, setTableState] = useSessionstorageState<{
  //   [key: string]: DataTableState
  // }>(Constants.SESSION_STORAGE_TABLE_KEY, {})

  // const customRestoreState = () => {
  //   return tableState[stateKey] || null
  // }

  // const customSaveState = (state: DataTableState) => {
  //   if (JSON.stringify(state) !== JSON.stringify(tableState[stateKey])) {
  //     setTableState({ ...tableState, [stateKey]: state })
  //   }
  // }

  // // filters
  // const initFilters = () => {
  //   // create filter object for filtering otherwise if you click clear on the filter the app will crash
  //   const filterObject: DataTableFilterMeta = config.columns.reduce(
  //     (acc: any, column) => {
  //       const key = column.filterField || column.field!
  //       const operator = column.filter ? FilterOperator.AND : undefined
  //       const constraints: DataTableFilterMetaData[] = [
  //         {
  //           value: null,
  //           matchMode:
  //             column.filterMatchMode || getFilterMatchMode(column.dataType),
  //         },
  //       ]

  //       acc[key] = { operator, constraints }

  //       return acc
  //     },
  //     {},
  //   )

  //   // add global filter
  //   filterObject.global = {
  //     value: null,
  //     matchMode: FilterMatchMode.CONTAINS,
  //   }

  //   return filterObject
  // }

  // const [filters, updateFilters] = useImmer<DataTableFilterMeta>(initFilters())

  // const clearFilter = () => {
  //   updateFilters(initFilters())
  //   if (setGlobalFilterValue) {
  //     setGlobalFilterValue('')
  //   }
  // }

  // useEffect(() => {
  //   updateFilters(draft => {
  //     // @ts-ignore
  //     draft['global'].value = globalFilterValue
  //   })
  // }, [isLoading, globalFilterValue, updateFilters])

  // const emptyMessage = (
  //   <EmptyMessage
  //     title={getConfigTranslation(config?.emptyMessageTitle)}
  //     details={getConfigTranslation(config?.emptyMessageDetails)}
  //     value={data}
  //     clearFilter={clearFilter}
  //   />
  // )

  // if (isLoading) {
  //   return (
  //     <LoadingTable
  //       config={config}
  //       checkboxen={checkboxen}
  //       buttons={buttons}
  //       hasLink={!!link}
  //       header={header}
  //     />
  //   )
  // }

  // function handleOnSelectionChange(e: any) {
  //   if (link) {
  //     navigate(`/${link}/${e.value.Id}`)
  //   } else {
  //     if (setSelected) {
  //       setSelected(e.value)
  //     }
  //     return
  //   }
  // }

  // const header = (
  //   <div className="table-header flex justify-content-between flex-wrap align-items-center gap-2">
  //     <h3 className="mr-auto my-1">{getConfigTranslation(config?.title)}</h3>

  //     {buttons}
  //   </div>
  // )

  const header = createHeader(headerTitle, headerActions, config)

  return (
    <TreeTable
      header={header}
      style={{ fontSize: '90%' }} // Something is wrong with the font-size when the TreeTable is used it goes to 16px instead of 14px like the other tables
      // ref={dataTableRef}
      // cellSelection={false}
      currentPageReportTemplate={t('common.table.numberOfEntries')}
      // dataKey={dataKey}
      // emptyMessage={emptyMessage}
      // filterDisplay="menu"
      // filters={filters}
      // onFilter={e => updateFilters(e.filters)}
      // header={header}
      // onSelectionChange={(e: any) => handleOnSelectionChange(e)}
      // paginator={
      //   tableState[stateKey]?.rows === Constants.MAX_ROWS_FOR_PRINT
      //     ? false
      //     : true
      // }
      // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      // rows={tableState[stateKey]?.rows || config.rows}
      // rowsPerPageOptions={config.rowsPerPageOptions}
      // scrollable
      // scrollHeight={
      //   tableState[stateKey]?.rows === Constants.MAX_ROWS_FOR_PRINT
      //     ? ''
      //     : config.scrollHeight || '400px'
      // }
      // selection={selected}
      // selectionMode={checkboxen ? 'checkbox' : 'single'}
      // selectionPageOnly
      // showGridlines
      // sortField={config.sortField}
      // sortOrder={config.sortOrder}
      // value={data}
      // sortMode={
      //   config?.multiSortMeta && config?.multiSortMeta?.length > 0
      //     ? 'multiple'
      //     : 'single'
      // }
      // multiSortMeta={config?.multiSortMeta}
      // stateStorage="custom"
      // stateKey={stateKey}
      // customRestoreState={customRestoreState}
      // customSaveState={customSaveState}
      {...props}
    >
      {/* columns */}
      {createTreeColumns(config.columns, props, checkboxen, buttons, children)}
      {/* {children} */}
    </TreeTable>
  )
}
